module.exports = __webpack_public_path__ + "img/8.278da703.jpg";